import { PayloadAction, createSlice } from "@reduxjs/toolkit"



export type CameraSlice = {
  returnPoint: CameraViewPoint | null;
  targetPoint: CameraViewPoint | null;
  showBoundaryDebug: boolean;
};

const initialState: CameraSlice = {
  showBoundaryDebug: false,
  returnPoint: null,
  targetPoint: null,
}


export const cameraSlice = createSlice({
  name: 'camera',
  initialState,
  reducers: {
    setTargetPoint(state, action: PayloadAction<CameraViewPoint | null>) {
      state.targetPoint = action.payload;
    },
    setReturnPoint(state, action: PayloadAction<CameraViewPoint | null>) {
      state.returnPoint = action.payload;
    },
    setTargetToReturnPoint(state, action: PayloadAction<boolean | null>) {
      if (state.returnPoint) {
        state.targetPoint = state.returnPoint;
      }
      if (action.payload) {
        state.returnPoint = null;
      }
    },
    setReturnPointToCurrent(state) {
      // find a better way later, now is just prototyping
      const position = (window as any).cameraRef.current.position;
      const target = (window as any).orbitRef.current.target;
      state.returnPoint = {
        position: [...position.toArray() as XYZ],
        target: [...target.toArray() as XYZ],
      }
    },
    setShowBoundaryDebug(state, action: PayloadAction<boolean>) {
      state.showBoundaryDebug = action.payload;
    },
    toggleBoundaryDebug(state) {
      state.showBoundaryDebug = !state.showBoundaryDebug;
    },
    reset(state) {
      state.targetPoint = null;
      state.returnPoint = null;
    }
  },
});

export const cameraReducer = cameraSlice.reducer;
export const cameraActions = cameraSlice.actions;

